/**
 * Okidači / pokretači za pluginove
 * */
$(document).ready(function () {

    /** Button loading.*/
    Ladda.bind('.btn-loading');



    /** select2*/
    $('.select2').select2({
        'language': {
            "noResults": function () {
                return "Nema razultata";
            }
        }
    });


    /** Master Slider*/
    var slider = new MasterSlider();
    slider.setup('masterslider', {
        width: 814,    // slider standard width
        autoHeight: true,
        space: 5,
        fullwidth: true,
        autoplay: true
    });
    // adds Arrows navigation control to the slider.
    slider.control('thumblist', {autohide: true, dir: 'h', arrows: false});
    slider.control('bullets', {autohide: false});

    /** iCheck*/
    $('input.icheck').iCheck({
        checkboxClass: 'icheckbox_square-blue',
        radioClass: 'iradio_square-blue',
        increaseArea: '20%'
    });

    /** Magnific popup*/
    $('.popup-gallery').magnificPopup({
        delegate: 'a',
        type: 'image',
        tLoading: 'Loading image #%curr%...',
        mainClass: 'mfp-img-mobile',
        gallery: {
            enabled: true,
            navigateByImgClick: true,
            preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
        },
        image: {
            tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
            titleSrc: function (item) {
                return item.el.attr('title');
            }
        }
    });
    $('.popup-video').magnificPopup({
        type: 'iframe'
    });
});

$(document).ajaxComplete(function () {
    $('input.icheck').iCheck({
        checkboxClass: 'icheckbox_square-blue',
        radioClass: 'iradio_square-blue',
        increaseArea: '20%'
    });
});
